import AdministrationNamingScheme from './AdministrationNamingScheme'

export default AdministrationNamingScheme
